










import Vue from "vue";
import MainColumns from "@/components/templates/MainColumns.vue";
import Notifications from "@/components/organisms/Notifications.vue";
import RoomWizard from "@/components/organisms/wizard/RoomWizard.vue";

export default Vue.extend({
  name: "template_main",
  data() {
    return {
      steps: [
        "connect",
        "license",
        "updates",
        "credentials",
        "language",
        "appearance",
        "complete",
      ],
    };
  },
  components: {
    RoomWizard,
    Notifications,
    MainColumns,
  },
});
